<script setup lang="ts">
import CarouselEssayMain from 'components/HomePage/CarouselEssayMain.vue'
import Loading from 'vue-loading-overlay';
</script>
<template>
  <div>
    <loading class="cover__load" v-model:active="loading" :is-full-page="false" color="#b20000" :opacity="0" />
    <section class="cover" v-if="cardPrincipal">
      <router-link :to="{
        name: 'ModelPage',
        params: { locale, name: cardPrincipal.url }
      }">
        <div :class="`cover__image ${opac}`">
          <CarouselEssayMain :card-images="!isMobile() ? cardPrincipal.home : cardPrincipal.homeMobile" :model-name="cardPrincipal.name"/>          
        </div>
        <div class="cover__info">
          <div class="container cont-top">
            <h2 class="cover__title" v-text="cardPrincipal.name"></h2>
            <h3 class="cover__description" v-text="cardPrincipal.description"></h3>
            <p class="cover__text" v-if="cardPrincipal.text" v-text="cardPrincipal.text"></p>
            <router-link :to="{
              name: 'ModelPage',
              params: { locale, name: cardPrincipal.url }
            }" class="button button--o">
              <span class="txt-button">{{ translate.buttomImageCardPrincipal }}</span>
              <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" class="btn-arrow" />
            </router-link>
          </div>
        </div>
      </router-link>
    </section>
    <section v-else>
      <CarouselEssayMain :card-images="!isMobile() ? imgsDesktop : imgsMobile" :model-name="'Model'"/>      
    </section>
    <section class="block block--black">
      <div class="container">
        <div class="model-list model-list--home">
          <swiper v-if="ultimosCards" :slidesPerView="1.07" :spaceBetween="10" :pagination="{ dynamicBullets: true, clickable: true }"
          :breakpoints="{
              '1040': {
                slidesPerView: 2,
                spaceBetween: 10
              }
            }" 
            :modules="[Pagination]" 
            class="mySwiper swp-sizes" 
            :style="`--swiper-pagination-color:white;--swiper-pagination-bullet-inactive-color:white;--swiper-pagination-bullet-size:12px;`"
          >
            <swiper-slide v-for="(item, index) in ultimosCards" :key="index">
              <model-list-item :name="item.name" :slug="item.url" :image="item.imgUrl"
                :mobile-image="item.imgUrl"></model-list-item>
            </swiper-slide>
          </swiper>
          <div v-else class="swp-sizes">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ModelListItem from 'components/ModelListItem.vue'
import translateMain from 'tradutors/menu'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import router from 'router'
import { isMobile } from 'views/shared/utils/mobile'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

// import required modules
import { Pagination } from 'swiper'

//Preload
import ImgPreloadDesktop from 'assets/img/home-desktop.webp'
import ImgPreloadMobile from 'assets/img/home-mobile.webp'

export default defineComponent({
  name: 'PhotoShooting',
  components: {
    ModelListItem,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      Pagination
    }
  },
  props: ['cardPrincipal', 'ultimosCards'],
  data() {
    return {
      swiperModelsOptions: {
        slidesPerView: screen.width < 769 ? 1 : 2,
        spaceBetween: 1,
        freeMode: true,
        loop: true,
        grabCursor: true
      },
      loading: true,
      infiniteScrolling: true,
      isMobile: isMobile(),      
      imgsDesktop: [ImgPreloadDesktop],
      imgsMobile: [ImgPreloadMobile],
      opac: 'opacity-0',
      swiperWidth: isMobile()?'350px':'1017px',
      swiperHeight: isMobile()?'350px':'450px',
    }
  },
  watch: {
    'cardPrincipal': function (val) {

      if (this.cardPrincipal.home.length == 1) {
        this.infiniteScrolling = false
      }
      if (val)
        this.loading = false
        this.opac = 'opacity-1'      
    }
  },
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return translateMain.portugues
      } else {
        return translateMain.ingles
      }
    }
  },
  methods: {
    redirect(name) {
      router.push({ name, params: { locale: this.locale, name: this.cardPrincipal.url } })
    },
  }
})
</script>

<style scoped lang="css">
.cover__info {
  width: 1440px;
  height: 715px;
}

.cover__load{
  width: 100%;
  height: 215px;
}

.cover__image img {
  width: 100%;
  object-fit: cover;
}

.swiper-slide {
  width: 496px !important;
  margin-right: 25px !important;
}

.model-list--home {
  margin-top: 0px;
  width: 1017px;
  height: 450px;  
}

.model-list--home>>>.model-list__item {
    width: 100%;
    height: 100%;
}

.model-list--home>>>.model-list__title {
  font-family: 'Roboto-Medium';
  height: 28px;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.model-list--home>>>.link {
  height: 19px;
  color: #999;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;
}

h3 h2 p {
  font-family: 'Roboto-Medium';
}

.cover__description {
  color: #FFFFFF;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: 15px;
}

.cover__title {
  color: #FFFFFF;
  font-family: "Bebas-Neue";
  font-size: 66px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 56px;
}

.cover__text {
  height: 76px;
  color: #FFFFFF;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 52px;
}

.btn-arrow {
  color: #b20000;
  margin-left: 10px;
  display: none;
}

:deep(.model-list__image img) {
  cursor: pointer;
  width: 496px;
  height: 364px;
}

.button {
  padding: 0 28px;
}

.cont-top {
  max-width: 1248px;
}

.block--black {
  width: 100%;
  height: 100%;
  padding-bottom: unset;
}

.swp-sizes {
  width: 1017px;
  height: 450px;  
  top: -35px;
}

@media screen and (max-width: 1140px) {
  .cover__text {
    display: none;
  }
}

@media screen and (max-width: 1040px) {
  .swiper-slide {
    width: 50% !important;
    left: 25%;
  }

  .cover__info {
    height: 450px;
  }
}

@media screen and (max-width: 769px) {

  .cover__title {
    display: block;
    font-size: 48px;
    line-height: 48px;
    margin-top: 20px;
  }

  .cover__info {
    position: relative;
    margin-bottom: 40px;
    -webkit-box-shadow: -1px -23px 68px 16px rgba(0, 0, 0, 0.92);
    -moz-box-shadow: -1px -23px 68px 16px rgba(0, 0, 0, 0.92);
    box-shadow: -1px -23px 68px 16px rgba(0, 0, 0, 0.92);
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 319px !important;
    height: 100% !important;
    left: 0%;
    margin-right: 12px !important;
  }

  :deep(.model-list__image img) {
    width: 100%;
    height: 234px;
  }


  .model-list--home {
    margin-top: 0px;
    width: 100%;
    height: 328px;
    padding-left: 0px;    
  }

  .btn-arrow {
    display: block;
  }

  .cover__description {
    margin-top: unset;
    max-width: 100%;
  }

  :deep(.model-list__info) {
    padding-right: 0px;
    padding-bottom: 15px;
  }

  .model-list--home>>>.model-list__title {
    font-family: 'Roboto-Medium';
    height: 28px;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .model-list--home>>>.link {
    height: 19px;
    color: #999999;
    font-family: "Exo-2";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: right;
    top: -3px;
  }

  .swiper-slide-next>>>.model-list__title {
    padding-left: 30px;
  }

  .swp-sizes {
    width: 350px;
    height: 350px;  
    top: -20px;
  }  
}

/* regras mobile 400px */
@media screen and (max-width: 400px) {
  .cover__title {
    display: block;
    font-size: 36px;
    line-height: 36px;
    margin-top: 20px;
  }

  .cover__description {
    font-size: 20px;
    margin-top: unset;
    max-width: 100%;
  }


}
</style>
